import WorkerApiService from "../../workerApiServices";

class RequisicaoEstoqueService extends WorkerApiService {

    constructor() {
        super('/api/requisicaoEstoque');
    }

    save(requisicaoEstoque) {
        return this.post('/save', requisicaoEstoque);
    }

    search() {
        return this.get('/search');
    }

    searchDepartamentos() {
        return this.get('/searchDepartamentos');
    }

    todosDepartamentos() {
        return this.get('/todosDepartamentos');
    }

    departamentosUsuario(usuarioId) {
        return this.get(`/departamentosUsuario?usuarioId=${usuarioId}`);
    }

    salvarDepartamentosUsuario(usuarioId, ids) {
        return this.post(`/departamentosUsuario?usuarioId=${usuarioId}`, ids);
    }

    efetivar(id) {
        return this.post(`/efetivar?id=${id}`);
    }

    cancelar(id) {
        return this.post(`/cancelar?id=${id}`);
    }

}

export default RequisicaoEstoqueService
